import {
  jb_listing_grid_css_default
} from "./chunk.MRGCYE6G.js";
import {
  Spaceable,
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.SUDKOARH.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ChangesBackgroundColor
} from "./chunk.A2J677GQ.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  e,
  n,
  o
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-listing-grid/jb-listing-grid.ts
var JbListingGrid = class extends ChangesBackgroundColor(Spaceable(r)) {
  firstUpdated() {
    this.style.setProperty("--_column-count", this.columns.toString());
    this._gridItems.forEach((gridItem) => {
      if (gridItem instanceof HTMLElement) {
        gridItem.setAttribute("role", "listitem");
      }
    });
  }
  _getContentSpacingProperties() {
    const gridCols = this.variant === "wide" ? 12 : void 0;
    return {
      colsMdUp: gridCols,
      horizontal: this.variant ?? void 0,
      type: this.headline ? "list" : "list-without-heading"
    };
  }
  _tracking(e2) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e2, {
      component_name: "listing"
    });
    if (jbTrackingEvent) this.dispatchEvent(jbTrackingEvent);
  }
  render() {
    return ke`
      <section
        aria-labelledby=${this.headline ? "listing-grid-title" : D}
        class=${Rt({ "listing-grid": true, [`cols${this.columns}`]: true, wide: this.variant === "wide" })}
      >
        ${this.headline ? ke`<h2
              id="listing-grid-title"
              class="title"
            >
              ${this.headline}
            </h2>` : D}
        <div
          class="columns"
          role="list"
        >
          <slot @jb-link:clicked=${this._tracking}></slot>
        </div>
      </section>
    `;
  }
};
JbListingGrid.styles = [reset_css_default, jb_listing_grid_css_default];
__decorateClass([
  n({ type: Number })
], JbListingGrid.prototype, "columns", 2);
__decorateClass([
  n()
], JbListingGrid.prototype, "headline", 2);
__decorateClass([
  n()
], JbListingGrid.prototype, "variant", 2);
__decorateClass([
  e("slot")
], JbListingGrid.prototype, "_grid", 2);
__decorateClass([
  o()
], JbListingGrid.prototype, "_gridItems", 2);
JbListingGrid = __decorateClass([
  customElement("jb-listing-grid")
], JbListingGrid);

export {
  JbListingGrid
};
